import React, { createContext, useContext, useMemo } from 'react';
import { getWidgetLabels } from '../../i18n/widgetLabels';

const WidgetLabelsContext = createContext(() => (key) => key);

export function WidgetLabelsProvider({ locale = 'en', children }) {
  const t = useMemo(() => getWidgetLabels(locale), [locale]);
  return <WidgetLabelsContext.Provider value={t}>{children}</WidgetLabelsContext.Provider>;
}

export function useWidgetLabels() {
  return useContext(WidgetLabelsContext);
}
